import Profile from "./Profile.jsx";

export default Profile;
